import { Home, Building2, Hotel, ArrowUpFromDot, ArrowDownToDot } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/918882183014?text=Hi%2C%20I%20want%20to%20book%20a%20water%20tank%20cleaning%20service%20in%20Gurugram";

const services = [
  {
    icon: Home,
    title: "Residential Tank Cleaning",
    desc: "Complete cleaning and disinfection of home water tanks. Safe for families, pets, and plants.",
  },
  {
    icon: Building2,
    title: "Commercial Tank Cleaning",
    desc: "Large-scale tank cleaning for offices, malls, and commercial complexes with minimal downtime.",
  },
  {
    icon: Hotel,
    title: "Hotel & Hospitality Cleaning",
    desc: "Specialized cleaning meeting hospitality industry hygiene standards and compliance requirements.",
  },
  {
    icon: ArrowUpFromDot,
    title: "Overhead Tank Cleaning",
    desc: "Expert cleaning of rooftop and elevated water storage tanks with high-pressure equipment.",
  },
  {
    icon: ArrowDownToDot,
    title: "Underground Tank Cleaning",
    desc: "Deep cleaning of underground water reservoirs including sludge removal and sanitization.",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <p className="text-sky font-medium text-sm uppercase tracking-[0.2em] mb-3">
            Our Services
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-navy">
            Comprehensive Cleaning Solutions
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={service.title}
              data-testid={`service-card-${i}`}
              className="group bg-surface border border-slate-200 rounded-xl p-8 hover:shadow-lg hover:-translate-y-1 hover:border-sky/50 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-sky/10 flex items-center justify-center mb-5 group-hover:bg-sky/20 transition-colors">
                <service.icon className="w-6 h-6 text-sky" />
              </div>
              <h3 className="font-heading font-semibold text-lg text-navy mb-3">
                {service.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-5">
                {service.desc}
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-book-btn-${i}`}
                className="inline-flex items-center text-sky font-medium text-sm hover:text-navy transition-colors group-hover:underline"
              >
                Book Now &rarr;
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
